'use strict';

import mediumZoom from 'medium-zoom';
import * as dom from './lib/dom.js';

function loadZoom() {
    // console.log('loadZoom');
    mediumZoom('.c-content-shield__main img', )
};

export default function() {
	window.addEventListener('load', function() {
		loadZoom();
	});
};
